import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import Body from '../Tugas-Intro-ReactJS/tugasIntroReact';
import TugasHooks from "../Tugas-Hooks/tugasHooks";
import CRUDHooks from '../TugasCRUDHooks/tugascrudhooks';
import AxiosMahasiswa from '../TugasAxios/tugasaxios';
import Buah from '../TugasContext/index';
import MahasiswaTable from "../NilaiMahasiswa/MahasiswaTable";
import MahasiswaForm from "../NilaiMahasiswa/MahasiswaForm";
import Navbar from "../Switch";
import DarkMode from "../Switch/SwitchTheme";
// import ThemeContext from "../ThemeContext";



const Routes = ()=> {

    return(
        <Router>
            <div>
                <Navbar/>

                <div className="App">
                    <Switch>
                        <Route exact path="/">
                            <TugasHooks/>
                            <Body/>
                        </Route>
                        <Route exact path="/crud-hooks">
                            <CRUDHooks/>
                        </Route>
                        <Route exact path="/axios">
                            <AxiosMahasiswa/>
                        </Route>
                        <Route exact path="/context">
                            <Buah/>
                        </Route>
                        <Route exact path="/nilai-mahasiswa">
                            <MahasiswaTable/>
                        </Route>
                        <Route exact path="/nilai-mahasiswa/create">
                            <MahasiswaForm/>
                        </Route>
                        <Route exact path="/nilai-mahasiswa/:id/edit">
                            <MahasiswaForm/>
                        </Route>
                        <Route exact path="/switch-theme">
                            <DarkMode/>
                        </Route>

                    </Switch>
                </div>
            </div>
        </Router>
    )
}

export default Routes